const namespace = '[ENTITY_SITE_CUSTOMERS]';

export const FETCH_SITE_CUSTOMERS = `${namespace} FETCH_SITE_CUSTOMERS`;
export const SET_SITE_CUSTOMERS = `${namespace} SET_SITE_CUSTOMERS`;
